import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tipoInput", "dataInicioInput", "iframe", "btnVisualizar", "btnBaixar", "spinner"]

  connect() {
    this.checkIframeLoaded()
    this.updatePreview()
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.style.display = "flex"
    }
    clearTimeout(this._spinnerTimeout)
    this._spinnerTimeout = setTimeout(() => {
      this.hideSpinner()
    }, 3000)
  }

  hideSpinner() {
    clearTimeout(this._spinnerTimeout)
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.style.display = "none"
    }
  }

  checkIframeLoaded() {
    if (!this.hasIframeTarget) return
    try {
      const doc = this.iframeTarget.contentDocument || this.iframeTarget.contentWindow?.document
      if (doc && (doc.readyState === "complete" || doc.readyState === "interactive")) {
        if (doc.location && doc.location.href !== "about:blank") {
          this.hideSpinner()
        }
      }
    } catch (e) {
      // Ignorar cross-origin
    }
  }

  get tipo() {
    return this.hasTipoInputTarget ? this.tipoInputTarget.value : "1"
  }

  get dataInicio() {
    return this.hasDataInicioInputTarget ? this.dataInicioInputTarget.value : ""
  }

  updatePreview(event) {
    if (event) {
      event.preventDefault()
    }

    const tipoVal = this.tipo
    const dataVal = this.dataInicio

    const reportHtmlUrl = `/dashboards/prestacao_contas/report?tipo=${encodeURIComponent(tipoVal)}&data_inicio=${encodeURIComponent(dataVal)}`
    const reportPdfInlineUrl = `/dashboards/prestacao_contas/report.pdf?tipo=${encodeURIComponent(tipoVal)}&data_inicio=${encodeURIComponent(dataVal)}&disposition=inline`
    const reportPdfAttachmentUrl = `/dashboards/prestacao_contas/report.pdf?tipo=${encodeURIComponent(tipoVal)}&data_inicio=${encodeURIComponent(dataVal)}&disposition=attachment`

    if (this.hasIframeTarget) {
      const currentSrc = this.iframeTarget.getAttribute("src")
      if (currentSrc !== reportHtmlUrl) {
        this.showSpinner()
        this.iframeTarget.src = reportHtmlUrl
      } else {
        this.checkIframeLoaded()
      }
    }

    if (this.hasBtnVisualizarTarget) {
      this.btnVisualizarTarget.href = reportPdfInlineUrl
    }

    if (this.hasBtnBaixarTarget) {
      this.btnBaixarTarget.href = reportPdfAttachmentUrl
    }
  }

  printReport(event) {
    if (event) {
      event.preventDefault()
    }

    const iframe = this.hasIframeTarget ? this.iframeTarget : null
    if (!iframe) return

    try {
      const iframeWin = iframe.contentWindow || iframe.contentDocument?.defaultView
      if (iframeWin) {
        iframeWin.focus()
        iframeWin.print()
      }
    } catch (e) {
      console.error("Erro ao imprimir via iframe:", e)
      if (this.hasBtnVisualizarTarget && this.btnVisualizarTarget.href) {
        window.open(this.btnVisualizarTarget.href, '_blank')
      }
    }
  }
}
